<template>
  <Cascader v-model="areaid" :data="areadata" placeholder="请选择省市区" class="inptext" change-on-select />
</template>

<script>
export default {

    props: { areaids: Array },
    data() {
        return {
            areaid: [],
	        areadata: []
        };
    },
    beforeCreate() {
        // 	let that = this;
        // let api = this.ApiUrl + 'area/findAllArea';
        // let data = {
        // 	'area_id':1,
        // }
        // this.$http.post(api, data).then(res => {
        
        // 	if (res.data.extend.news == 0) {
        // 		let list = res.data.extend.area;
        // 		that.areadata = list;
        // 		for(var i =0;i<that.areadata.length;i++){
        // 			if(!that.areadata[i].children){
        // 				that.areadata[i].children = that.areadata[i].list2
        // 			}
        // 		}
        //
        // 	}
        // }, res => {
        //
        // })

    },
    mounted() {
        this.getsheng();
        // this.areaid = this.areaids;
       
    },
    methods: {

        getsheng() {
            const that = this;
            const api = this.ApiUrl + 'area/findAllArea';
            const data = {
                'area_id': 1
            };
            this.$http.post(api, data).then(res => {
                
                if (res.data.extend.news === 0) {
                    const list = res.data.extend.area;
                    that.areadata = list;

                    for (var i = 0; i < that.areadata.length; i++) {
                        if (!that.areadata[i].children) {
                            that.areadata[i].children = that.areadata[i].list2;
                        }
                    }
                    this.areaid = this.areaids;
                    
                }
            }, res => {

            });
        }

    }
};
</script>

<style scoped>
</style>
